import React, { useEffect, useRef } from 'react';
import { Wrapper } from './date_selector.style';
import DateSelector from './date_selector';

// @source param: expect the following format:
// [
//   { columns: ['27th Janauary 2021', '94.1%'], value: '3030' },
//   { columns: ['10th Janauary 2021', '79.2%'], value: '3031' },
//   { columns: ['9th Janauary 2022', '84.7%' ], value: '3032' },
//   { columns: ['12th September 2019', '72.3%'], value: '3033' } ,
//   { columns: ['11th October 2018', '93.3%'], value: '3034' },
// ];
// @handleSelectedDate expects a function, you can define it in your component and passing in. e.g.
// const [selectedDate, setSelectedDate] = useState(undefined);
// const handleSelectedDate = (date: React.SetStateAction<undefined>) => {
//   setSelectedDate(date);
// }

function DatePicker ({ source, handleSelectedDate, isHotelSelector }) {
  const datesPickerRef = useRef<HTMLInputElement>(null);
  const dataSource = source.map((item) => ({
    labels: item.columns,
    value: item.value,
  }));

  useEffect(() => {
    const dateSelectorInstance = new DateSelector({
      el: datesPickerRef.current,
      type: 'normal',
      source: dataSource,
      count: 20,
      onChange: (selected: { value: number }) => {
        handleSelectedDate(selected);
      },
      isHotelSelector,
    });

    return () => {
      dateSelectorInstance.destroy();
    };
  }, []);

  return (
    <Wrapper>
      <div className="date-selector">
        <div className="drilldown" ref={datesPickerRef} />
      </div>
    </Wrapper>
  );
}

export default DatePicker;
